import { MenuItem } from "../../../../_metronic/layout/components/header/header-menus/MenuItem"
// import { useAuth } from "../../auth"
import { MenuInnerWithSub } from "../../../../_metronic/layout/components/header/header-menus/MenuInnerWithSub";
import { useAppView } from "../../core/app/AppViewContext"
import { ApplicantPagesMenu } from "./ApplicantPagesMenu";

const ApplicantMenuInner = () => {

    // const {hasRole} = useAuth();
    const { cntApplications, cntDLMSiteInspectApplications, cntDLMDOCApplications, cntDLMLabelApplications } = useAppView();

    return(
    <>    

    <MenuInnerWithSub
        isMega={true}
        title='Directory'
        to='/directory'
        menuPlacement='bottom-start'
        menuTrigger='click'        
      >
        <ApplicantPagesMenu />
      </MenuInnerWithSub>

    { (cntApplications > 0) && 
       <MenuItem title="COC Applications" to='/company/application-management' showCount={cntApplications} />
    }

    { (cntDLMSiteInspectApplications > 0) && 
        <MenuItem title="Site Inspections" to='/company/doclabel/siteinspection-applications-list' showCount={cntDLMSiteInspectApplications} />    
    }     

    { (cntDLMDOCApplications > 0) && 
        <MenuItem title="DOC Applications" to='/company/doclabel/doc-applications-list' showCount={cntDLMDOCApplications} />    
    }

    { (cntDLMLabelApplications > 0) && 
        <MenuItem title="Label Applications" to='/company/doclabel/label-applications-list' showCount={cntDLMLabelApplications} />    
    }        
    </>
    )    
}

export {ApplicantMenuInner}